import React from 'react';
import { CardMedia } from '@mui/material';
import CallToActionContent from './CallToActionContent';

const CallToActionBudget = () => (
    <CallToActionContent
        callToActionHref={new URL('https://www.manty.eu/contactbudget')}
        featureList={[
            'cta.budget.feature_1',
            'cta.budget.feature_2',
            'cta.budget.feature_3',
        ]}
        moreInfoHref={new URL('https://www.manty.eu/budget')}
        title="cta.budget.title"
        description="cta.budget.description"
        bgColor="#EBF6FE"
    >
        <CardMedia
            sx={{
                borderWidth: '0',
                maxHeight: '500px',
                aspectRatio: '16/9',
            }}
            component="iframe"
            src="https://player.vimeo.com/video/558521897?h=76448a91a5&color=e9815f&title=0&byline=0&portrait=0"
        />
    </CallToActionContent>
);

export default CallToActionBudget;
